import type {CmPictureType} from '../components/types';

export function isAiGeneratedImage(picture?: CmPictureType | null): boolean {
    return picture?.mediaSettings?.aiGeneratedImage === true;
}

export function getAiGeneratedImageHintText(picture?: CmPictureType | null): string | null {
    const hintText = picture?.mediaSettings?.aiGeneratedImageHintText;
    return typeof hintText === 'string' && hintText.trim().length > 0 ?
        hintText.trim() :
        null;
}
